export const reatDecreto = {
  id: 'static-reat-decreto',
  slug: 'reat-decreto',
  title: 'Un successo targato UNASCA: nasce il ReAT!',
  excerpt: 'Il Decreto che formalizza la costituzione del ReAT è stato pubblicato! Un sogno diventato realtà che segna l\'inizio di una nuova era professionale.',
  body: `
    <div style="background: linear-gradient(135deg, #0066cc 0%, #3385d6 100%); color: white; padding: 2rem; border-radius: 12px; margin: 2rem 0; text-align: center; box-shadow: 0 10px 30px rgba(0, 102, 204, 0.3);">
      <h2 style="font-size: 2rem; margin-bottom: 1rem; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); font-weight: 600;">
        Un successo targato UNASCA
      </h2>
      <p style="font-size: 1.2rem; margin: 0;">Il Decreto che formalizza la costituzione del ReAT è stato pubblicato!</p>
    </div>

    <div style="text-align: center; margin: 2rem 0;">
      <img src="/images/reat.jpg" alt="Decreto MIT ReAT - Registro Unico Agenzie Telematiche" style="width: 100%; max-width: 800px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
    </div>

    <h2>Lettera del Segretario Nazionale</h2>

    <p>Ebbene sì, <strong style="color: #0066cc;">possiamo festeggiare!</strong></p>

    <p>Il Decreto che formalizza la costituzione del <strong style="color: #00bf8f;">ReAT (Registro Unico delle Agenzie Telematiche)</strong> è stato pubblicato sul sito del MIT, ne alleghiamo copia.</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 1.5rem; margin: 2rem 0; text-align: center;">
      <h3 style="color: #00bf8f; margin-bottom: 1rem;">
        <i class="fas fa-external-link-alt"></i> Riferimento Ufficiale MIT
      </h3>
      <p style="margin-bottom: 1.5rem; color: #6c757d;">
        Consulta il decreto ufficiale pubblicato dal Ministero delle Infrastrutture e dei Trasporti
      </p>
      <a href="https://www.mit.gov.it/normativa/decreto-capo-dipartimento-numero-200-del-16062025" target="_blank" style="display: inline-flex; align-items: center; gap: 0.5rem; background: #00bf8f; color: white; padding: 0.8rem 1.5rem; border-radius: 50px; text-decoration: none; font-weight: 600; box-shadow: 0 4px 15px rgba(0, 191, 143, 0.3);">
        <i class="fas fa-file-alt"></i> Decreto n. 200 del 16/06/2025
      </a>
    </div>

    <div style="background: linear-gradient(135deg, #0066cc 0%, #3385d6 100%); color: white; padding: 2rem; border-radius: 12px; margin: 2rem 0; text-align: center; box-shadow: 0 10px 30px rgba(0, 102, 204, 0.3);">
      <h2 style="font-size: 1.8rem; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);">🏆 Un sogno diventato realtà.</h2>
    </div>

    <p>Qualcuno si ricorderà quando ci eravamo inventati la <strong style="color: #00bf8f;">formazione obbligatoria</strong> per iscriversi alla nostra associazione?</p>

    <p>Bene, oggi è diventata <strong style="color: #0066cc;">obbligatoria per poter fare questa professione</strong>. Un salto triplo in avanti, e la stessa formazione poi è demandata alle <strong>Associazioni di Categoria</strong>, insomma, meglio di così non potevamo chiedere.</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.1) 0%, rgba(32, 201, 151, 0.1) 100%); border: 1px solid rgba(0, 191, 143, 0.3); border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 0 20px rgba(0, 191, 143, 0.1);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem;">
        <i class="fas fa-lightbulb"></i> La visione di UNASCA
      </h3>
      <p>È davvero un piacere constatare quanto l'Unasca sia stata <strong style="color: #00bf8f;">visionaria</strong>, quell'esperimento partì circa <strong>25 anni fa</strong>, ed oggi possiamo dire di averci visto lungo, di aver capito che <strong>senza formazione non può esserci una professione</strong>.</p>
    </div>

    <h2>Una nuova fase organizzativa</h2>
    <p>Poi ci concentreremo sulla fase organizzativa, sarà complessa, vorrà dire fare corsi a circa <strong style="color: #00bf8f;">5000 studi di consulenza</strong>, ma rimandiamo queste preoccupazioni a dopo i festeggiamenti, sì, <strong style="color: #0066cc;">oggi è il momento di festeggiare</strong>, oggi siamo una categoria professionale alla pari delle altre, anzi, mi permetto di dire, visto il Decreto, meglio di tante altre. Ma anche qui avremo modo di approfondire tutti gli aspetti.</p>

    <h2>Ringraziamenti</h2>
    <p>Oggi voglio solo dire, e dobbiamo dirlo tutti, <strong style="color: #0066cc; font-size: 1.2rem;">GRAZIE UNASCA</strong>, grazie a chi ha sempre lavorato guardando al futuro, grazie ai visionari, a chi ha buttato sempre il cuore oltre l'ostacolo, a chi non si è lasciato scoraggiare davanti alle difficoltà.</p>

    <blockquote style="background: #f8f9fa; border-left: 4px solid #00bf8f; padding: 1.5rem; margin: 2rem 0; font-style: italic; font-size: 1.1rem; border-radius: 0 12px 12px 0;">
      <strong style="color: #00bf8f;">"Da oggi inizia una nuova fase, tutta nuova, tutta da costruire, noi stiamo già pensando avanti, alle prossime sfide, e ce ne sono tante, ma Unasca c'è, insieme a tutti voi."</strong>
    </blockquote>

    <div style="text-align: right; margin-top: 3rem; padding-top: 2rem; border-top: 2px solid #eee; font-weight: 600; color: #001510;">
      <p>Un caro saluto.</p>
      <br>
      <p><strong>Il Segretario Nazionale Studi<br>Giuseppe Guarino</strong></p>
      <p style="font-style: italic; color: #6c757d; margin-top: 0.5rem;">19 giugno 2025</p>
    </div>
  `,
  featuredImage: '/images/mit_reat.jpg',
  category: {
    id: 'normative',
    name: 'Normative',
    slug: 'normative',
    color: '#F59E0B'
  },
  tags: ['ReAT', 'Registro Unico', 'MIT', 'Formazione Obbligatoria', 'Decreto', 'Professione'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-06-19T10:00:00Z',
  createdAt: '2025-06-19T10:00:00Z',
  updatedAt: '2025-06-19T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 3
};

